<nav *ngIf="goBackLink" mat-tab-nav-bar>
  <a mat-tab-link *ngFor="let link of tabLinks"
     (click)="navigateBackToParent()"
     (click)="setLinkActive(link)"
     [active]="link.active"
     routerLinkActive="link">
    <mat-icon>arrow_back</mat-icon>
    <span style="color: black;font-weight: 500">ZURÜCK</span></a>
</nav>
